<template>
  <div>
<!--    <PageAllow-->
<!--      controller="ReturnOrders"-->
<!--      :action="isNew ? 'add' : isView ? 'view' : mode"-->
<!--    />-->
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t(isNew ? "CRUD.newInfo" : isEdit ? "CRUD.editInfo" : "CRUD.info", [
                  $t("ReturnOrder.ObjectName"),
                ])
              }}
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="order.status | returnOrderStatusColor"
                :text-color="order.status | returnOrderStatusTextColor"
                >{{ order.status | returnOrderStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="!isNew && savable"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="mode = 'view'"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToView") }}
                </v-btn>
                <v-btn
                  v-if="mode == 'edit'"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("ReturnOrder.actions.editOrderSubmit") }}
                </v-btn>
              </v-sheet>
              <OrderActions
                v-if="isView"
                :order="order"
                detail-mode
                showEdit
                @edit="mode = 'edit'"
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.order_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.actual_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ order.actual_date | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.shop") }}{{ $t("Global.colon") }}
                  </span>
                  [{{ order && order.shop ? order.shop.shop_code : "" }}]
                  {{ order && order.shop ? order.shop.shop_name : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnOrder.Fields.memo") }}{{ $t("Global.colon") }}
                  </span>
                  <Required :show="savable" :mode="mode" />
                  <v-text-field
                    v-if="savable"
                    v-model="order.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ order.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 退货类型 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text pt-1">
                    {{ $t("ReturnOrder.Fields.type") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      returnType == 1
                        ? $t("ReturnOrder.Type.on")
                        : returnType == 2
                        ? $t("ReturnOrder.Type.off")
                        : returnType == 3
                        ? $t("ReturnOrder.Type.both")
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card class="px-4 mt-4">
        <v-toolbar flat class="transparent-background-color">
          <v-row no-gutters align="center">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("ReturnOrder.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <span
              v-if="savable"
              class="secondary--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("ReturnOrder.Fields.price_in_edit")
              }}{{ $t("Global.colon") }}
            </span>
            <span
              v-if="savable"
              class="accent--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("Global.money") }}{{ price_fix | formatMoneyFloor }}
            </span>
          </v-row>
        </v-toolbar>
        <v-divider />
        <ValidationObserver ref="observer">
          <v-data-table
            id="order_details_table"
            :headers="detailsHeaders"
            :items="orderDetails"
            :search="filter"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                          "$vuetify.dataFooter.pageText",
                          order_details
                              ? [
                                order_details.length > 0 ? 1 : 0,
                                order_details.length,
                                order_details.length,
                              ]
                              : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td></td>
                <td></td>
                <td>
                  <span v-if="savable">
                    <v-select
                      v-model="returnTypeAll"
                      single-line
                      dense
                      hide-details
                      style="
                        max-width: 140px;
                        margin-right: auto;
                        margin-left: auto;
                      "
                      :items="[
                        { text: $t('ReturnOrder.Type.on'), value: 1 },
                        { text: $t('ReturnOrder.Type.off'), value: 2 },
                      ]"
                      item-text="text"
                      item-value="value"
                      clearable
                    />
                  </span>
                </td>
                <td align="right">
                  {{ apply_num_total | formatTwoDot }}
                </td>
                <td></td>
                <td></td>
                <td align="right">
                  {{ $t("Global.money") }}{{ price_fix | formatMoneyFloor }}
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row" v-if="!isNew">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReturnOrder.DetailFields.apply_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ apply_num_total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ReturnOrder.DetailFields.total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ price_fix | formatMoneyFloor }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.category_name="{ item }">
              <span class="text-no-wrap">
                {{ item.category_name }}
              </span>
            </template>
            <template v-slot:item.Description="{ item }">
<!--              <a-->
<!--                class="text-no-wrap"-->
<!--                :class="item.error_flg ? 'red&#45;&#45;text' : ''"-->
<!--                @click.stop="dialogMaterialID = item.material_id"-->
<!--              >-->
                <span>
                  {{ item.material_name }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("ReturnOrder.DetailFields.standard") }}{{ $t("Global.colon") }}
                  <span
                      v-if="item.standard_name && item.standard_name.length > 12"
                      :title="item.standard_name"
                      style="cursor: pointer"
                  >
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
<!--              </a>-->
            </template>
            <template v-slot:item.apply_num="{ item }">
              <ValidationProvider
                v-if="isEdit"
                :name="$t('ReturnOrder.DetailFields.apply_num')"
                v-slot="{ errors }"
                :rules="{
                  required:true,
                  min_value: 0,
                }"
              >
                <NumberInput
                  v-model="item.apply_num"
                  :error-messages="errors"
                  dense
                />
              </ValidationProvider>
              <span v-else>
                {{ item.apply_num | formatTwoDot }}
              </span>
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-if="savable"
                v-model="item.price"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                 item.price =
                    item.price == ''
                      ? 0
                      : $numberFormatter.formatMoneyFloor(item.price);
                "
                  style="max-width: 80px; margin-left: auto"
                  @input="updateItemSums()"
              />
              <span v-else>
                {{ $t("Global.money") }}{{ item.price | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.return_type="{ item }">
              <v-select
                v-if="savable"
                v-model="item.return_type"
                single-line
                dense
                hide-details
                style="max-width: 140px; margin-right: auto; margin-left: auto"
                :items="[
                  { text: $t('ReturnOrder.Type.on'), value: 1 },
                  { text: $t('ReturnOrder.Type.off'), value: 2 },
                ]"
                item-text="text"
                item-value="value"
                @change="resetReturnType()"
              />
              <span v-else>
                {{
                  item.return_type == 1
                    ? $t("ReturnOrder.Type.on")
                    : item.return_type == 2
                        ? $t("ReturnOrder.Type.off")
                        : ""
                }}
              </span>
            </template>
            <template v-slot:item.total="{ item }">
              {{ $t("Global.money") }}{{ item.total | formatMoneyFloor }}
            </template>
          </v-data-table>
        </ValidationObserver>
      </v-card>
    </v-sheet>

  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
// import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import OrderActions from "./plugins/Actions";
import NumberInput from "@/components/plugins/NumberInput";
import ReturnOrders from "@/api/return_orders";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    // PageAllow,
    Breadcrumbs,
    Required,
    OrderActions,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        this.mode == "new" || this.mode == "edit"
      );
    },
    isNew() {
      return this.mode == "new";
    },
    isEdit() {
      return this.mode == "edit";
    },
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnOrderManagement"),
          disabled: false,
          replace: true,
          href: "/return-orders",
        },
        {
          text: i18n.t("Nav.returnOrderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.order && this.order.order_code ? this.order.order_code : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      let headers = [
        {
          text: i18n.t("ReturnOrder.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.material"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.return_type"),
          align: "center",
          value: "return_type",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.apply_num"),
          align: "end",
          value: "apply_num",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.unit"),
          align: "center",
          value: "unit",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.price"),
          align: "end",
          value: "price",
        },
        {
          text: i18n.t("ReturnOrder.DetailFields.total"),
          align: "end",
          value: "total",
        }
      ];
      // if (this.settings && this.settings.product_date_setting) {
      //   headers.push({
      //     text: i18n.t("ReturnOrder.DetailFields.production_date"),
      //     align: "start",
      //     value: "production_date",
      //     width: 136,
      //   });
      //   headers.push({
      //     text: i18n.t("ReturnOrder.DetailFields.expired_date"),
      //     align: "start",
      //     value: "expired_date",
      //     width: 136,
      //   });
      // }
      headers.push({
        text: i18n.t("ReturnOrder.DetailFields.memo"),
        align: "start",
        sortable: false,
        value: "memo",
      });
      //
      // if (!this.isView)
      //   headers.push({
      //     text: i18n.t("TableHeaders.actions"),
      //     align: "start",
      //     sortable: false,
      //     value: "actions",
      //   });
      // if (!this.isNew)
      //   headers.push({
      //     text: i18n.t("ReturnOrder.DetailFields.attachments"),
      //     align: "start",
      //     sortable: false,
      //     value: "attachments",
      //   });
      return headers;
    },
    orderDetails() {
      return this.order_details
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode) {
      this.$router.replace("/return-orders/" + this.$route.params.accountId + "/" + this.$route.params.id);
    }
  },

  data: () => ({
    panels: [0],
    mode: "",
    price_fix: 0,
    order: {},
    order_details: [],
    filter: "",
    memo_dialog: false,
    detail_memo_item: { memo: "" },
    dialogMaterialID: null,
    returnType: 2,
    apply_num_total: 0,
    returnTypeAll: 0,
  }),

  methods: {
    getOrderFromAPI() {
      ReturnOrders.fetchOne(this.$route.params.id, { account_id: this.$route.params.accountId }).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.return_order == null) {
              this.$snackbar.error(i18n.t("ReturnOrder.viewErrorMsg"));
              this.$router.push("/return-orders");
            }
            this.order = response.data.return_order;
            this.returnType = this.order.return_type;
          }
        }.bind(this)
      );
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            let postData = {
              order_code: this.order.order_code,
              account_id: this.$route.params.accountId,
              memo: this.order.memo,
              return_type: this.order.return_type,
              order_details: []
            };
            let details = [];
            this.order_details.forEach((detail) => {
              details.push({
                "id": detail.id,
                "material_code": detail.material_code,
                "apply_num": detail.apply_num,
                "price": detail.price,
                "auto_flg": detail.auto_flg,
                "unit": detail.unit
              })
            });
            postData.order_details = details
            ReturnOrders.edit(postData).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/return-orders");
                } else if (response.data.error.code == "ERR759") {
                  //退货单切单失败
                  this.mode = "view";
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    updateItemSums() {
      let priceFix = 0;
      let apply_num_total = 0;
      this.order_details.forEach((detail) => {
        let apply_num = detail.apply_num ? detail.apply_num : 0;
        apply_num_total += Number(apply_num);
        detail.total = parseFloat(
            this.$numberFormatter.formatMoneyFloor(
                parseFloat((detail.price *  apply_num).toFixed(4))
            )
        );
        priceFix += Number(detail.total);
        priceFix = parseFloat(priceFix.toFixed(2));
      });
      this.order.price_fix = this.price_fix = priceFix;
      this.apply_num_total = apply_num_total;
    },
    resetReturnType() {
      let onCount = 0;
      let offCount = 0;
      this.orderDetails.map(function (detail) {
        if (detail.return_type == 1) {
          onCount++;
        } else {
          offCount++;
        }
      });
      this.returnType = onCount == 0 ? 2 : offCount == 0 ? 1 : 3;
    },
  },

  watch: {
    $route(to, from) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/return-orders/" + to.params.accountId + "/" + to.params.id);
      } else if (
        from.path.startsWith("/return-order-new") &&
        from.path != to.path
      ) {
        this.mode = "view"; // 从return-order-new退回时触发状态变化和数据重加载
      }
    },
    mode: {
      handler() {
        if (this.$route.params.accountId && this.$route.params.id) {
          this.getOrderFromAPI();
        }
      },
    },
    order: {
      deep: true,
      handler() {
        this.order_details =
          this.order && this.order.order_details
            ? this.order.order_details
            : [];
        this.price_fix = this.order ? this.order.price_fix : 0;
      },
    },
    order_details: {
      deep: true,
      handler() {
        let priceFix = 0;
        let apply_num_total = 0;
        this.order_details.forEach((detail) => {
          let apply_num = detail.apply_num ? detail.apply_num : 0;
          apply_num_total += Number(apply_num);
          detail.total = parseFloat(
              this.$numberFormatter.formatMoneyFloor(
                  parseFloat((detail.price *  apply_num).toFixed(4))
              )
          );
          priceFix += Number(detail.total);
          priceFix = parseFloat(priceFix.toFixed(2));
        });
        this.order.price_fix = this.price_fix = priceFix;
        this.apply_num_total = apply_num_total;
      },
    },
    returnTypeAll: {
      handler() {
        if (this.returnTypeAll == 1 || this.returnTypeAll == 2) {
          this.returnType = this.returnTypeAll;
          this.order_details = this.order_details.map(
            function (detail) {
              detail.return_type = this.returnTypeAll;
              return detail;
            }.bind(this)
          );
        }
      },
    },
  },
};
</script>
